import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UserListComponent } from './userList.component';
import { UserManagementComponent } from './userManagement.component';
import { UserEditComponent } from './userEdit.component';
import { UserCreateComponent } from './userCreate.component';
import { UserEditProfileComponent } from './userEditProfile.component';
import { UserEditDigestComponent } from './userEditDigest.component';
import { UserEditTopicsComponent } from './userEditTopics.component';
import { UserEditBriefingsComponent } from './userEditBriefings.component';
import { UserEditGroupsComponent } from './userEditGroups.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        FlexLayoutModule,
        FormsModule,
        GeneralModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MomentModule,
        RouterModule,
        InfiniteScrollModule,
    ],
    declarations: [
        UserCreateComponent,
        UserEditComponent,
        UserEditDigestComponent,
        UserEditGroupsComponent,
        UserEditBriefingsComponent,
        UserEditProfileComponent,
        UserEditTopicsComponent,
        UserListComponent,
        UserManagementComponent
    ],
    exports: [
        UserCreateComponent,
        UserEditComponent,
        UserListComponent,
        UserManagementComponent
    ],
    entryComponents: [
    ]
})
export class UsersModule {
}